import googleTagManager from '@analytics/google-tag-manager';
import { AnalyticsProvider as AnalyticsProvider_ } from '@inflearn/analytics';
import { Analytics as _Analytics } from 'analytics';
import type { ReactNode } from 'react';

// @see https://tagmanager.google.com/?authuser=3#/container/accounts/3094205941/containers/8964582/workspaces/
const projectAnalytics = googleTagManager({
  containerId: 'GTM-MVM7ZHX',
});

// @see https://tagmanager.google.com/?authuser=3#/container/accounts/3094205941/containers/227247071/workspaces/
const commonAnalytics = Object.assign(
  {},
  googleTagManager({
    containerId: 'GTM-58GKPFHR',
    dataLayerName: 'commonDataLayer',
  }),
  {
    name: 'common',
  },
);

export const analytics = _Analytics({
  app: 'inflearn-monolith',
  plugins: [projectAnalytics, commonAnalytics],
});

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  return <AnalyticsProvider_ analytics={analytics}>{children}</AnalyticsProvider_>;
}
